import type { Connection } from "@shared/api/generated/model";
import { Tag, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";

export const feederConnectionColumns: ColumnsType<Connection> = [
  { title: "ID", dataIndex: "id", width: 70 },
  {
    title: "Статус",
    dataIndex: "state",
    width: 90,
    render: (v?: number | null) =>
      v === 0 ? <Tag color="green">Вкл</Tag> : <Tag color="red">Выкл</Tag>,
  },
  {
    title: "Название",
    dataIndex: "name",
    ellipsis: { showTitle: false },
    render: (v?: string | null) => <Tooltip title={v}>{v || "—"}</Tooltip>,
  },
  {
    title: "Хост:порт",
    key: "host_port",
    width: 160,
    render: (_: unknown, r: Connection) =>
      r.host && r.tcp_port ? `${r.host}:${r.tcp_port}` : (r.host ?? "—"),
  },
  {
    title: "Переподключ.",
    dataIndex: "interval",
    width: 120,
    render: (v?: string | null) => v || "—",
  },
];
